function renderSubtotal(qqt) {
  if (qqt === 1) {
    return 960;
  } else {
    return 800 * qqt;
  }
}

export default renderSubtotal;
